const initialState = {
    tasks: [],
    error: null,
    isLoding: false
  };
  
  const TaskApiReducer = (state = initialState, action) => {
    switch (action.type) {
      case "LOADING":
        return {
          ...state,
          isLoding: action.payload
        };
  
      case "GET_TASKS_SUCCESS":
        return {
          ...state,
          tasks: action.payload,
          error: null
        };
      case "GET_TASKS_FAILURE":
        return {
          ...state,
          error: action.payload.error
        };
  
      case "ADD_TASK_SUCCESS":
        return {
          ...state,
          error: null
        };
      case "ADD_TASK_FAILURE":
        return {
          ...state,
          error: action.payload.error
        };
  
      case "UPDATE_TASK_SUCCESS":
        return{
          ...state,
          error: action.payload.error
        };
  
      case "UPDATE_TASK_FAILURE":
        return{
          ...state,
         
          error: action.payload.error
        };
      
      case "DELETE_TASK_SUCCESS":
        return{
          ...state,
          tasks: state.tasks.filter((task) => task.id !== action.payload),
          error: null
        };
  
      case "DELETE_TASK_FAILURE":
        return{
          ...state,
          error: action.payload.error
        }
  
      default:
        return state;
    }
  };
  
  export default TaskApiReducer;
  
